// Routes match the old Wix site's URLs so existing links & search results keep working
export const PAGE_ROUTES = {
  HOME: "/",
  SHOP: "/shop",
  //One page per shop category: /nuts, /dried-fruit... (see SHOP_CATEGORIES)
  CATEGORY: "/:categorySlug",
  PRODUCT: "/product-page/:productSlug",
  RECIPES: "/recipes",
  ABOUT: "/about",
  FACILITY: "/our-facility",
  CERTIFICATION: "/certification",
  CONTACT: "/contact",
  CART: "/cart",
  ORDER_RESULT: "/order/:result",
};

export const getProductRoute = (slug) => (
  PAGE_ROUTES.PRODUCT.replace(":productSlug", slug)
);

// The Wix store categories. A product's Category field lists the ones it's in ("Nuts, Mixes").
// inFilter: shown in the shop page's category filter (Bars & Cakes only have their own - currently empty - pages).
//inFilter: in the shop's category filter; inMenu: under "Shop" in the side menu (as on Wix)
export const SHOP_CATEGORIES = [
  { name: "Dried Fruit", slug: "dried-fruit", inFilter: true, inMenu: true },
  { name: "Mixes", slug: "mixes", inFilter: true, inMenu: true },
  { name: "Nuts", slug: "nuts", inFilter: true, inMenu: true },
  { name: "Savoury", slug: "savoury", inFilter: true, inMenu: true },
  { name: "Seeds", slug: "seeds", inFilter: true, inMenu: false },
  { name: "Bars", slug: "bars", inFilter: false, inMenu: true },
  { name: "Cakes", slug: "cakes", inFilter: false, inMenu: true },
];

//The shop page or one of the category pages - where a product page's "Back to Shop" returns to
export const isShopPage = (pathname) => (
  (pathname === PAGE_ROUTES.SHOP) || SHOP_CATEGORIES.some((c) => pathname === `/${c.slug}`)
);

//The smallest order (before delivery) the checkout accepts - the server checks appsettings "MinimumOrder" too
export const MINIMUM_ORDER = 400;

//Shown in the home page slider
export const BEST_SELLERS = "Best Sellers";

export const CONTACT_DETAILS = {
  EMAIL: "info@gabysearthfoods.co.za",
  PHONE: "+27 11 397 4685",
  PHONE_LINK: "tel:+27113974685",
  ADDRESS: ["226 Brakpan Road,", "Boksburg East, Johannesburg"],
  MAP: "https://www.google.com/maps/search/?api=1&query=Gaby%27s+Earth+Food+226+Brakpan+Road+Boksburg",
  FACEBOOK: "https://www.facebook.com/GabysEarthFoods",
  INSTAGRAM: "https://www.instagram.com/gabys_earth_foods/",
  TAPX: "http://www.tap-x.com/",
};

export const ADMIN_PAGE_ROUTES = {
  HOME: "/admin",
  ORDERS: "/admin/orders",
  ORDER: "/admin/orders/:orderID",
  PRODUCTS: "/admin/products",
  PRODUCT: "/admin/products/:productID",
  ANALYTICS: "/admin/analytics",
  ACCOUNT: "/admin/account",
};

export const getAdminOrderRoute = (orderID) => (
  ADMIN_PAGE_ROUTES.ORDER.replace(":orderID", orderID)
);

//"new" opens an empty product form
export const getAdminProductRoute = (productID) => (
  ADMIN_PAGE_ROUTES.PRODUCT.replace(":productID", productID)
);

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  LOGIN: "ls_1",
  CONTACT_SEND: "ls_2",
  CHECKOUT: "ls_3",
  ORDER_STATUS: "ls_4",
  PRODUCTS: "ls_5",
};

export const LS_ITEM_ADMIN = {
  SUMMARY_LOAD: "lsa_1",
  ORDERS_LOAD: "lsa_2",
  ORDER_LOAD: "lsa_3",
  ORDER_SAVE: "lsa_4",
  EXPORT: "lsa_5",
  PASSWORD_SAVE: "lsa_6",
  PRODUCTS_LOAD: "lsa_7",
  PRODUCT_LOAD: "lsa_8",
  PRODUCT_SAVE: "lsa_9",
  PRODUCT_DELETE: "lsa_10",
  IMAGES_UPDATE: "lsa_11",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};

export const PAYMENT_STATUS = {
  PENDING: "Pending",
  PAID: "Paid",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  REFUNDED: "Refunded",
};

export const FULFILMENT_STATUS = {
  NEW: "New",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};

//"How can we help?" on the contact form (same as the Wix form)
export const CONTACT_TOPICS = [
  "Order Query",
  "Private Label",
  "Whole Sale",
  "General",
];

export const PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "North West",
  "Northern Cape",
  "Western Cape",
];
